export const RecaptchaLowScoreErrorResponse = 'Recaptcha score is lower than threshold'

export const isRecapthcaLowScoreError = (errorMessage: string): boolean => {
  return errorMessage === RecaptchaLowScoreErrorResponse
}
